import { render, staticRenderFns } from "./subjectAuditDetail.vue?vue&type=template&id=97e98d12&scoped=true&"
import script from "./subjectAuditDetail.vue?vue&type=script&lang=js&"
export * from "./subjectAuditDetail.vue?vue&type=script&lang=js&"
import style0 from "./subjectAuditDetail.vue?vue&type=style&index=0&id=97e98d12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e98d12",
  null
  
)

export default component.exports